import { initShow } from '~/issues';

initShow();
